import { useState, useEffect } from "react";
import { useI18n } from "../lib/i18n.jsx";
import { subscribeMyTeams, unpublishMarketplaceTeam } from "../lib/api.js";
import { navigateTo } from "../App.jsx";

export default function MyTeams({ user }) {
  const { t } = useI18n();
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    if (!user) { navigateTo("/?login=1"); return; }
    const unsub = subscribeMyTeams(setTeams);
    return unsub;
  }, [user]);

  async function handleUnpublish(teamId) {
    if (!confirm("Unpublish this team?")) return;
    try {
      await unpublishMarketplaceTeam({ teamId });
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <div className="my-teams">
      <div className="my-teams-header">
        <h2>{t("your_teams")}</h2>
        <button className="btn btn-primary" onClick={() => navigateTo("/publish")}>
          + {t("publish_team")}
        </button>
      </div>

      {teams.length === 0 ? (
        <div className="empty-state"><p>{t("no_teams")}</p></div>
      ) : (
        <div className="teams-manage-list">
          {teams.map((team) => (
            <div key={team.id} className="team-manage-card">
              <div className="team-manage-info">
                <h4>{team.name}</h4>
                <span className={`status-badge ${team.status}`}>
                  {team.status === "published" ? t("status_published") : t("status_draft")}
                </span>
              </div>
              <div className="team-manage-meta">
                <span>★ {team.avgRating?.toFixed(1) || "—"}</span>
                <span>{t("install_count", { n: team.installCount || 0 })}</span>
              </div>
              <div className="team-manage-actions">
                <button className="btn btn-secondary btn-sm" onClick={() => navigateTo(`/edit/${team.id}`)}>
                  {t("edit_team")}
                </button>
                {team.status === "published" && (
                  <button className="btn btn-ghost btn-sm" onClick={() => handleUnpublish(team.id)}>
                    {t("unpublish")}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
